export const environment = {
  url: 'https://beta.landinventur.de/rest/',
  tileUrl: 'https://c.tile.openstreetmap.org/{z}/{x}/{y}.png',
  nominatimUrl: 'https://nominatim.openstreetmap.org/search.php',
  production: true,
  release: 2
};
